// import './_components.js';

document.addEventListener("DOMContentLoaded", (event) => {
  // console.log("DOM fully loaded and parsed");

  let isMobile = {
    Android: function () {
      return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function () {
      return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function () {
      return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function () {
      return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function () {
      return navigator.userAgent.match(/IEMobile/i);
    },
    any: function () {
      return (
        isMobile.Android() ||
        isMobile.BlackBerry() ||
        isMobile.iOS() ||
        isMobile.Opera() ||
        isMobile.Windows()
      );
    },
  };

  if (isMobile.any()) {
    document.body.classList.add("_touch");

    let menuArrows = document.querySelectorAll(".nav__arrow");
    if (menuArrows.length > 0) {
      for (let i = 0; i < menuArrows.length; i++) {
        const menuArrow = menuArrows[i];
        menuArrow.addEventListener("click", function (e) {
          menuArrow.parentElement.classList.toggle("_active");
        });
      }
    }
  } else {
    document.body.classList.add("_pc");
  }

  // Меню бургер
  const iconMenu = document.querySelector(".nav__icon");
  const menuBody = document.querySelector(".js-nav");
  // const bg = document.getElementById("bg");
  if (iconMenu) {
    iconMenu.addEventListener("click", function (e) {
      document.body.classList.toggle("_lock");
      // bg.classList.toggle("_active");
      iconMenu.classList.toggle("_active");
      menuBody.classList.toggle("_active");
    });
  }

  const popupLinks = document.querySelectorAll(".popup-link");
  const body = document.querySelector("body");
  const lockPadding = document.querySelectorAll(".lock-padding");
  let unlock = true;
  const timeout = 800;

  if (popupLinks.length > 0) {
    for (let index = 0; index < popupLinks.length; index++) {
      const popupLink = popupLinks[index];
      popupLink.addEventListener("click", function (e) {
        const popupName = popupLink.getAttribute("href").replace("#", "");
        const curentPopup = document.getElementById(popupName);
        popupOpen(curentPopup);
        e.preventDefault();
      });
    }
  }

  const popupCloseIcon = document.querySelectorAll(".close-popup");
  if (popupCloseIcon.length > 0) {
    for (let index = 0; index < popupCloseIcon.length; index++) {
      const el = popupCloseIcon[index];
      el.addEventListener("click", function (e) {
        popupClose(el.closest(".popup"));
        e.preventDefault();
      });
    }
  }

  function popupOpen(curentPopup) {
    if (curentPopup && unlock) {
      const popupActive = document.querySelector(".popup.open");
      disableScroll();
      if (popupActive) {
        popupClose(popupActive, false);
      } else {
        bodyLock();
        enableScroll();
      }
      curentPopup.classList.add("open");
      curentPopup.addEventListener("click", function (e) {
        if (!e.target.closest(".popup__content")) {
          popupClose(e.target.closest(".popup"));
        }
      });
    }
  }

  function popupClose(popupActive, doUnlock = true) {
    if (unlock) {
      popupActive.classList.remove("open");
      if (doUnlock) {
        bodyUnLock();
      }
    }
  }

  function bodyLock() {
    const lockPaddingValue =
      window.innerWidth -
      document.querySelector(".page__body").offsetWidth +
      "px";

    if (lockPadding.length > 0) {
      for (let index = 0; index < lockPadding.length; index++) {
        const el = lockPadding[index];
        el.style.paddingRight = lockPaddingValue;
      }
    }
    body.style.paddingRight = lockPaddingValue;
    body.classList.add("lock");

    unlock = false;
    setTimeout(function () {
      unlock = true;
    }, timeout);
  }

  let fixBlocks = document.querySelectorAll(".fix-block");

  // disable enable scroll
  let disableScroll = function () {
    let paddingOffset = window.innerWidth - document.body.offsetWidth + "px";
    document.body.classList.add("disable-scroll");
    fixBlocks.forEach((el) => {
      el.style.paddingRight = paddingOffset;
    });
    document.body.style.paddingRight = paddingOffset;
  };

  let enableScroll = function () {
    document.body.classList.remove("disable-scroll");
    fixBlocks.forEach((el) => {
      el.style.paddingRight = "0";
    });
    document.body.style.paddingRight = "0";
  };

  function bodyUnLock() {
    setTimeout(function () {
      if (lockPadding.length > 0) {
        for (let i = 0; i < lockPadding.length; i++) {
          const el = lockPadding[i];
          el.style.paddingRight = "0px";
        }
      }
      body.style.paddingRight = "0px";
      body.classList.remove("lock");
    }, timeout);

    unlock = false;
    setTimeout(function () {
      unlock = true;
    }, timeout);
  }

  document.addEventListener("keydown", function (e) {
    if (e.which === 27) {
      const popupActive = document.querySelector(".popup.open");
      popupClose(popupActive);
    }
  });

  (function () {
    if (!Element.prototype.closest) {
      Element.prototype.closest = function (s) {
        var el = this;

        do {
          if (Element.prototype.matches.call(el, s)) return el;
          el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1);
        return null;
      };
    }
  })();

  (function () {
    // проверяем поддержку
    if (!Element.prototype.matches) {
      // определяем свойство
      Element.prototype.matches =
        Element.prototype.matchesSelector ||
        Element.prototype.webkitMatchesSelector ||
        Element.prototype.mozMatchesSelector ||
        Element.prototype.msMatchesSelector;
    }
  })();

  // Фиксируем шапку при прокрутке сайта
  let header = document.querySelector(".js-nav"),
    headerH = document.querySelector(".js-nav").clientHeight;

  // let viewportWidth = window.innerWidth;

  document.onscroll = function () {
    let scroll = window.scrollY;

    // if (scroll > headerH + 120 && viewportWidth >= 560) {
    if (scroll > headerH + 100) {
      header.classList.add("fixed");
      document.body.style.paddingTop = headerH + "px";
    } else {
      header.classList.remove("fixed");
      document.body.removeAttribute("style");
    }
  };

  //* Swiper
  const swiperSlider = new Swiper(".mainTopSlider", {
    slidesPerView: 1,
    loop: true,
    keyboard: true,
    effect: "fade",
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
      type: "bullets",
      dynamicBullets: true,
      dynamicMainBullets: 3,
    },
  });

  // * Carouserl
  const swiperCarousel = new Swiper(".mainCarousel", {
    slidesPerView: 6,
    loop: true,
    keyboard: true,
    // mousewheel: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      // when window width is >= 480px
      480: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      // when window width is >= 640px
      640: {
        slidesPerView: 4,
        spaceBetween: 40,
      },
      1200: {
        slidesPerView: 6,
        spaceBetween: 40,
      },
    },
  });

  // * Tabs Контакты
  let hash = window.location.hash;
  let href = window.location.href;
  const russTab = document.getElementById("russ-tab");
  const kazTab = document.getElementById("kaz-tab");
  const belTab = document.getElementById("bel-tab");
  const armTab = document.getElementById("arm-tab");
  const kyrTab = document.getElementById("kyr-tab");
  const russia = document.getElementById("russia");
  const kaz = document.getElementById("kaz");
  const bel = document.getElementById("bel");
  const arm = document.getElementById("arm");
  const kyr = document.getElementById("kyr");

  console.log(hash);
  // console.log(href);

  if (href === "https://ibp-impuls.ru/kontakty.html") {
    kaz.classList.remove("active");
    kazTab.classList.remove("active");
    bel.classList.remove("active");
    belTab.classList.remove("active");
    arm.classList.remove("active");
    armTab.classList.remove("active");
    russia.classList.add("active");
    russTab.classList.add("active");
  }
  if (href === "https://ibp-impuls.ru/kontakty.html#russia-tab") {
    kaz.classList.remove("active");
    kazTab.classList.remove("active");
    bel.classList.remove("active");
    belTab.classList.remove("active");
    arm.classList.remove("active");
    armTab.classList.remove("active");
    russia.classList.add("active");
    russTab.classList.add("active");
  }
  if (href === "https://ibp-impuls.ru/kontakty.html#bel-tab") {
    russia.classList.remove("active");
    russTab.classList.remove("active");
    kaz.classList.remove("active");
    kazTab.classList.remove("active");
    arm.classList.remove("active");
    armTab.classList.remove("active");
    bel.classList.add("active");
    belTab.classList.add("active");
  }
  if (href === "https://ibp-impuls.ru/kontakty.html#kaz-tab") {
    russia.classList.remove("active");
    russTab.classList.remove("active");
    arm.classList.remove("active");
    armTab.classList.remove("active");
    bel.classList.remove("active");
    belTab.classList.remove("active");
    kaz.classList.add("active");
    kazTab.classList.add("active");
  }
  if (href === "https://ibp-impuls.ru/kontakty.html#arm-tab") {
    russia.classList.remove("active");
    russTab.classList.remove("active");
    kaz.classList.add("active");
    kazTab.classList.remove("active");
    bel.classList.remove("active");
    belTab.classList.remove("active");
    arm.classList.add("active");
    armTab.classList.add("active");
  }
  if (href === "https://ibp-impuls.ru/kontakty.html#kyr-tab") {
    russia.classList.remove("active");
    russTab.classList.remove("active");
    kaz.classList.add("active");
    kazTab.classList.remove("active");
    bel.classList.remove("active");
    belTab.classList.remove("active");
    arm.classList.remove("active");
    armTab.classList.remove("active");
    kyr.classList.add("active");
    kyrTab.classList.add("active");
  }

  const mySelect = document.getElementById("mySelect"); // Получаем элемент селекта

  mySelect.addEventListener("change", function () {
    const selectedValue = this.value; // Получаем значение выбранной опции
    localStorage.setItem("selectedOption", selectedValue); // Сохраняем в localStorage
  });
  window.addEventListener("load", function () {
    const savedValue = localStorage.getItem("selectedOption");
    if (savedValue) {
      const mySelect = document.getElementById("mySelect");
      mySelect.value = savedValue; // Устанавливаем сохраненное значение
    }
  });

  // Scroll to top btn
  const topBtn = document.querySelector(".top-btn");
  topBtn.addEventListener("click", () => {
    window.scrollTo(0, 0);
  });
  const btnVisibility = () => {
    if (window.scrollY > 500) {
      topBtn.classList.add("show-btn__hide");
    } else if (window.scrollY < 500) {
      topBtn.classList.remove("show-btn__hide");
    }
  };
  document.addEventListener("scroll", () => btnVisibility());

  /* fancyapps */

  const mainCarousel = Carousel(
    document.getElementById("mainCarousel"),
    {
      // Your custom options
    },
    { Lazyload, Arrows, Thumbs }
  ).init();

  Fancybox.bind("[data-fancybox]", {
    // Your custom options
  });

  //! End DOMContentLoaded
});
